import { CheckboxListFormik } from '@strata/react-checkbox-list';
import { Hyperlink } from '@strata/react-hyperlink';
import * as Yup from 'yup';

import { AppRoutes } from 'services/routes';

interface BidTermsAndConditionsCheckboxProps {
    disabled?: boolean;
    namePrefix?: string;
}

export const BidTermsAndConditionsCheckbox = ({
    disabled = undefined,
    namePrefix = undefined,
}: BidTermsAndConditionsCheckboxProps) => (
    <div className="sds_bid-terms__checkbox">
        <CheckboxListFormik
            name={`${namePrefix ? `${namePrefix}.` : ''}terms`}
            required
            disabled={disabled}
            options={[
                {
                    value: 'terms',
                    component: (
                        <span>
                            <span>{'I agree to the '}</span>
                            <Hyperlink
                                linkText="Terms & Conditions."
                                id="bid-terms-and-conditions-link"
                                navUrl={AppRoutes.termsAndConditions}
                            />
                            <span className="sds_bid-terms__checkbox--required">*</span>
                        </span>
                    ),
                },
            ]}
        />
    </div>
);

BidTermsAndConditionsCheckbox.initialValues = (isChecked?: boolean) => ({
    terms: isChecked ? ['terms'] : [],
});

const validationMessage = 'Must agree to Terms & Conditions.';
BidTermsAndConditionsCheckbox.validationSchema = {
    terms: Yup.array(Yup.string().required(validationMessage))
        .required(validationMessage)
        .length(1, validationMessage),
};
